function cov_8r8r176wj() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/LockFilled.tsx";
  var hash = "be9055a7e38a8ad8ae393cd4cf2dc7b5e299eb5e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/LockFilled.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 51
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "be9055a7e38a8ad8ae393cd4cf2dc7b5e299eb5e"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_8r8r176wj = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_8r8r176wj();
var Icon = (cov_8r8r176wj().s[0]++, {
  name: 'lock-filled',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 1.75C9.1005 1.75 6.75 4.10051 6.75 7V10H5C3.89543 10 3 10.8954 3 12V20C3 21.1046 3.89543 22 5 22H19C20.1046 22 21 21.1046 21 20V12C21 10.8954 20.1046 10 19 10H17.25V7C17.25 4.10051 14.8995 1.75 12 1.75ZM14.75 10V7C14.75 5.48122 13.5188 4.25 12 4.25C10.4812 4.25 9.25 5.48122 9.25 7V10H14.75Z\" fill=\"currentColor\"/>"
});
export default Icon;